import { privacyPolicyPdf } from "../../assets/pdf/Pdfs";

export const PrivacyPolicy = () => {
  return (
    <div className="flex">
      <iframe className="x100 vh100" src={privacyPolicyPdf} />
    </div>
  );
};
